/// <reference path="../_references.ts"/>

module App.Administrative.SendInvoice {
	export type InvoiceResponse = {
		message: string;
	}

	export type Invoice = {
		latest_invoice_id: Number;
		note: string;
	}
}